import * as React from 'react';
import Modal from "react-responsive-modal";
import {useState} from "react";
import Icons from "../../Icons";
import {getShopRefInStorage} from "../../MonCompteAction";

interface ThumbnailUploadPreviewProps {
  bgColor: string,
  fileRegisteredSize: string,
  fileRegisteredOriginalName: string,
  fileRegisteredId: string | null,
  fromGallery: boolean,
  BatFilename: string,
  pathLoadBat: string,
  marquageId: number
}

export const ThumbnailUploadPreview = (props: ThumbnailUploadPreviewProps) => {
  const [openZoom, setOpenZoom] = useState(false);
  const fusionQuadriluxe= props.marquageId == 1 ? 'multiply' : 'unset';
  const renderFileSize = () => {
    if (props.fileRegisteredSize) {
      return (
        <div>
          <span className="bold">Poids : </span> {(Number(props.fileRegisteredSize) / 1000000).toFixed(2)} Mo
        </div>
      );
    }
  };

  const renderImportedFromGallery = () => {
    if (props.fromGallery) {
      return (
        <div className="grey italic mt-2 d-flex align-items-center">
          <Icons icon="collections" size={15} color="#888" />
          <span className="pl-1">Sélectionnée depuis votre galerie d'images</span>
        </div>
      );
    }
  }

  const renderImportedFileName = () => {
    return (
      <div className={'d-flex justify-content-between'}>
        <div style={{ wordBreak: 'break-all' }}>
          <span className="bold mr-2">Fichier :</span>
          {props.fileRegisteredOriginalName}
        </div>
        {renderFileSize()}
        {renderImportedFromGallery()}
      </div>
    );
  };

  const renderZoomModal = () => {
    const isDT = getShopRefInStorage() === 'DT';
    let styleContainer = { maxHeight: '760px', overflow: 'auto'};
    const bgColor = isDT && props.bgColor === '#ffffff' ? {} : {backgroundColor: props.bgColor};
    const classContainer = isDT && props.bgColor === '#ffffff' ? 'bg-alpha-bat-auto' : '';
    styleContainer =  {...styleContainer, ...bgColor};
    return (
      <Modal open={openZoom} onClose={() =>setOpenZoom(false)} center
             classNames={{overlay: 'bootstrap-container', modal: 'zoomFileModalContainer customModal',
               closeButton: 'zoomFileModalCloseButton closeButton'}}>
        <div className={`p-2 ${classContainer}`} style={styleContainer}>
          <div className="text-center">
            <img key={props.BatFilename}
                 src={props.pathLoadBat}
                 style={{ maxHeight: '740px', maxWidth: '900px', mixBlendMode: fusionQuadriluxe }} className={`p-1 ${getShopRefInStorage() === 'DT' ? 'bg-alpha' : ''}`} />
          </div>
        </div>
        {renderImportedFileName()}
      </Modal>
    );
  };

  if(props.pathLoadBat) {
    let styleContainer = { height: 'inherit'};
    const isDT = getShopRefInStorage() === 'DT';
    const bgColor = isDT && props.bgColor === '#ffffff' ? {} : {backgroundColor: props.bgColor};
    const classContainer = isDT && props.bgColor === '#ffffff' ? 'bg-alpha-bat-auto' : '';
    styleContainer =  {...styleContainer, ...bgColor};
    return (
        <div className={`d-flex align-items-center ${classContainer} flex-grow`} style={styleContainer}>
          <div onClick={() => setOpenZoom(true)}>
            <img key={props.BatFilename}
                 src={props.pathLoadBat}
                 className={`p-1 ${getShopRefInStorage() === 'DT' ? 'bg-alpha' : ''}`}
                 style={{maxWidth: '82px', maxHeight: '82px', mixBlendMode: fusionQuadriluxe}}/>
          </div>
          {renderZoomModal()}
        </div>
    );
  } else {
    return null;
  }
}
